import { forwardRef, type ReactNode } from 'react';
import { SvgIcon, type SvgIconProps } from '@mui/material';

export type CreateSvgIconOptions = {
  displayName: string;
  viewBox: string;
};

/**
 * Wraps custom SVG paths in MUI `SvgIcon` so icons match theme sizing and `currentColor`.
 */
export function createSvgIcon(paths: ReactNode, { displayName, viewBox }: CreateSvgIconOptions) {
  const Component = forwardRef<SVGSVGElement, SvgIconProps>(function UiIcon(props, ref) {
    return (
      <SvgIcon ref={ref} viewBox={viewBox} fill="none" {...props}>
        {paths}
      </SvgIcon>
    );
  });

  Component.displayName = displayName;
  return Component;
}
